/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Engineering
 * @graph-business TanStack Query キー定義。auth/resolver の階層的クエリキーでキャッシュ管理
 * @graph-connects none
 */
export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    current: ['auth', 'current'] as const,
  },
  resolver: {
    all: ['resolver'] as const,
    accounts: () => [...queryKeys.resolver.all, 'accounts'] as const,
  },
} as const;
